module.exports = __webpack_public_path__ + "static/img/jp_skzhgl.1eb99fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fajs/jp_skzhgl.png
// module id = HrsA
// module chunks = 1